import { createGlobalStyle } from "styled-components";

const fontsPath = "//assets.smartfit.com.br/fonts";

export const GlobalStyle = createGlobalStyle`

@font-face {
    font-display: swap;
    font-family: 'Roboto';
    font-weight: 300;
    font-style: normal;
    src: local('Roboto Light'),
      local('Roboto-300'),
      url("${fontsPath}/roboto/Roboto-300.woff") format('woff'),
      url("${fontsPath}/roboto/Roboto-300.ttf") format('truetype'),
      url("${fontsPath}/roboto/Roboto-300.eot"),
      url("${fontsPath}/roboto/Roboto-300.eot?#iefix") format('embedded-opentype'),
      url("${fontsPath}/roboto/Roboto-300.svg#Roboto") format('svg');
  }
  @font-face {
    font-display: swap;
    font-family: 'Roboto';
    font-weight: 400;
    font-style: normal;
    src: local('Roboto'),
      local('Roboto-regular'),
      url("${fontsPath}/roboto/Roboto-regular.woff") format('woff'),
      url("${fontsPath}/roboto/Roboto-regular.ttf") format('truetype'),
      url("${fontsPath}/roboto/Roboto-regular.eot"),
      url("${fontsPath}/roboto/Roboto-regular.eot?#iefix") format('embedded-opentype'),
      url("${fontsPath}/roboto/Roboto-regular.svg#Roboto") format('svg');
  }
  @font-face {
    font-display: swap;
    font-family: 'Roboto';
    font-weight: 700;
    font-style: normal;
    src: local('Roboto Bold'),
      local('Roboto-700'),
      url("${fontsPath}/roboto/Roboto-700.woff") format('woff'),
      url("${fontsPath}/roboto/Roboto-700.ttf") format('truetype'),
      url("${fontsPath}/roboto/Roboto-700.eot"),
      url("${fontsPath}/roboto/Roboto-700.eot?#iefix") format('embedded-opentype'),
      url("${fontsPath}/roboto/Roboto-700.svg#Roboto") format('svg');
  }
  @font-face {
    font-display: swap;
    font-family: 'Roboto';
    font-weight: 900;
    font-style: normal;
    src: local('Roboto Black'),
      local('Roboto-900'),
      url("${fontsPath}/roboto/Roboto-900.woff") format('woff'),
      url("${fontsPath}/roboto/Roboto-900.ttf") format('truetype'),
      url("${fontsPath}/roboto/Roboto-900.eot"),
      url("${fontsPath}/roboto/Roboto-900.eot?#iefix") format('embedded-opentype'),
      url("${fontsPath}/roboto/Roboto-900.svg#Roboto") format('svg');
  }
  @font-face {
    font-display: swap;
    font-family: 'Gotham';
    font-weight: 400;
    font-style: normal;
    src: local('Gotham Book'),
      local('Gotham-Book'),
      url("${fontsPath}/gotham/GothamHTF-Book.woff"),
      url("${fontsPath}/gotham/GothamHTF-Book.otf");
  }
  @font-face {
    font-display: swap;
    font-family: 'Gotham';
    font-weight: 700;
    font-style: normal;
    src: local('Gotham'),
      local('Gotham-Medium'),
      url("${fontsPath}/gotham/GothamHTF-Medium.woff"),
      url("${fontsPath}/gotham/GothamHTF-Medium.otf");
  }
  @font-face {
    font-display: swap;
    font-family: 'Gotham Ultra Italic';
    font-style: italic;
    src: local('Gotham Ultra Italic'),
      local('Gotham-Ultra-Italic'),
      url("${fontsPath}/gotham/Gotham-Ultra-Italic.woff"),
      url("${fontsPath}/gotham/Gotham-Ultra-Italic.ttf");
  }
  @font-face {
    font-display: swap;
    font-family: 'Gotham Black';
    font-style: normal;
    src: local('Gotham Black'),
      local('Gotham-Black-Regular'),
      url("${fontsPath}/gotham/Gotham-Black-Regular.woff"),
      url("${fontsPath}/gotham/Gotham-Black-Regular.ttf");
  }

    :root{
        --black: #212121;
        --black-action: #000000;
        --white: #fff;
        --gray: #F4F4F5;
        --gray-border: #e9e9e9;
        --gray-bg: #f4f4f4;
        --yellow: #FFB611;
        --yellow-alert: #FFF0D2;
        --yellow-border-alert: #FFB612;
        --yellow-bg-modal: #FFE0A6;
    }

    *{
        margin: 0;
        padding: 0;
        box-sizing: border-box;
    }

    html{
        @media(max-width: 1080px){
            font-size: 93.75%;
        }
        @media(max-width: 720px){
            font-size: 87.5%;
        }
    }

    body{
        background-color: var(--white);
        color: var(--black);
        -webkit-font-smoothing: antialiased;
        font-family: "Gotham", "Roboto", "Verdana", "Geneva", "Tahoma", "sans-serif";
    }

    body, input, textarea, button{
        font-family: "Gotham"
    }
    
    h1, h2, h3, h4, h5, h6, strong{
        font-weight: 600;
    }

    button{
        cursor: pointer;
    }

    [disabled]{
        opacity: 0.6;
        cursor: not-allowed;
    }
`;
